import { render } from "./AddFollowUpOverlay.vue?vue&type=template&id=2485e47c&scoped=true&lang=pug"
import script from "./AddFollowUpOverlay.vue?vue&type=script&lang=js"
export * from "./AddFollowUpOverlay.vue?vue&type=script&lang=js"

import "./AddFollowUpOverlay.vue?vue&type=style&index=0&id=2485e47c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2485e47c"]])

export default __exports__